<div class="tarefe-container" *ngIf="options">
  <div class="bg-image"></div>
  <div
    class="toggle-action-closed"
    id="tarefeActionButton"
    *ngIf="!toggle"
    matRipple
    (click)="toggleTarefe()"
  >
    <div class="title" fxLayout="row" fxLayoutAlign="space-between center">
      <span>تعرفه‌ها</span>
      <span>
        <jam-icon
          [name]="toggle ? 'chevron-right' : 'chevron-left'"
          [size]="30"
        ></jam-icon>
      </span>
    </div>
  </div>
  <div
    class="toggle-action-opened"
    *ngIf="toggle"
    id="openedToggleButton"
    matRipple
    (click)="toggleTarefe()"
  >
    <div class="title" fxLayout="row" fxLayoutAlign="space-between center">
      <span>تعرفه‌ها</span>
      <span>
        <jam-icon
          [name]="toggle ? 'chevron-right' : 'chevron-left'"
          [size]="30"
        ></jam-icon>
      </span>
    </div>
  </div>
  <div class="content" fxLayout="column">
    <div class="size-select" fxLayout="row" fxLayoutAlign="space-evenly center">
      <section
      class="size latin-num"
      (click)="selectSize(printSizesEnum.A5)"
      [class.selected]="selectedSize === printSizesEnum.A5"
      >
        A5
      </section>
      <section
        class="size selected latin-num"
        (click)="selectSize(printSizesEnum.A4)"
        [class.selected]="selectedSize === printSizesEnum.A4"
      >
        A4
      </section>
      <section
        class="size latin-num"
        (click)="selectSize(printSizesEnum.A3)"
        [class.selected]="selectedSize === printSizesEnum.A3"
      >
        A3
      </section>
    </div>
    <div
      class="pages-colors"
      fxLayout="row"
      fxLayoutAlign="space-evenly center"
    >
      <div class="column" fxLayout="column" fxLayoutAlign="space-evenly center">
        <div class="paper-wrapper">
          <div class="paper-size latin-num">{{selectedSize}}</div>
          <div class="paper-type grayscale">یک رو</div>
          <div class="paper-price">{{ getPrice("onesided.bw") | number : '1.' }}</div>
        </div>
        <div class="paper-wrapper">
          <div class="paper-size latin-num">{{selectedSize}}</div>
          <div class="paper-type halfcolor">یک رو</div>
          <div class="paper-price">{{ getPrice("onesided.hc") | number : '1.' }}</div>
        </div>
        <div class="paper-wrapper">
          <div class="paper-size latin-num">{{selectedSize}}</div>
          <div class="paper-type fullcolor">یک رو</div>
          <div class="paper-price">{{ getPrice("onesided.c") | number : '1.' }}</div>
        </div>
      </div>
      <!-- <div
        class="column pages onesided-pages"
        fxLayout="column"
        fxLayoutAlign="space-evenly center"
      >
        <div class="page single grayscale">
          <div class="bg"></div>
          <div class="content" fxLayout="column">
            <span class="title">یک رو</span>
            <span class="price">{{ getPrice("onesided.bw") }}</span>
          </div>
        </div>
        <div class="page single page-half-color">
          <div class="bg"></div>
          <div class="content" fxLayout="column">
            <span class="title">یک رو</span>
            <span class="price"> {{ getPrice("onesided.hc") }} </span>
          </div>
        </div>
        <div class="page single">
          <div class="bg"></div>
          <div class="content" fxLayout="column">
            <span class="title">یک رو</span>
            <span class="price"> {{ getPrice("onesided.c") }} </span>
          </div>
        </div>
      </div> -->
      <div
        class="column colors"
        fxLayout="column"
        fxLayoutAlign="space-evenly start"
      >
        <div class="color">
          <div class="title">سیاه و سفید</div>
        </div>
        <div class="color">
          <div class="title">نیمه رنگی</div>
        </div>
        <div class="color">
          <div class="title">تمام رنگی</div>
        </div>
      </div>
      <!-- <div
        class="column pages twosided-pages"
        fxLayout="column"
        fxLayoutAlign="space-evenly"
      >
        <div class="page double grayscale">
          <div class="bg"></div>
          <div class="content" fxLayout="column">
            <span class="title">دو رو</span>
            <span class="price"> {{ getPrice("twosided.bw") }} </span>
          </div>
        </div>
        <div class="page double page-half-color">
          <div class="bg"></div>
          <div class="content" fxLayout="column">
            <span class="title">دو رو</span>
            <span class="price"> {{ getPrice("twosided.hc") }} </span>
          </div>
        </div>
        <div class="page double">
          <div class="bg"></div>
          <div class="content" fxLayout="column">
            <span class="title">دو رو</span>
            <span class="price"> {{ getPrice("twosided.c") }} </span>
          </div>
        </div>
      </div> -->
      <div class="column" fxLayout="column" fxLayoutAlign="space-evenly center">
        <div class="paper-wrapper twosided">
          <div class="paper-size latin-num">{{selectedSize}}</div>
          <div class="paper-type grayscale">دو رو</div>
          <div class="paper-price">{{ getPrice("twosided.bw") | number : '1.' }}</div>
        </div>
        <div class="paper-wrapper twosided halftwosided">
          <div class="paper-size latin-num">{{selectedSize}}</div>
          <div class="paper-type halfcolor">دو رو</div>
          <div class="paper-price">{{ getPrice("twosided.hc") | number : '1.' }}</div>
        </div>
        <div class="paper-wrapper twosided fulltwosided">
          <div class="paper-size latin-num">{{selectedSize}}</div>
          <div class="paper-type fullcolor">دو رو</div>
          <div class="paper-price">{{ getPrice("twosided.c") | number : '1.' }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
